<template>
  <div id="app">
    <md-content class="md-scrollbar">
      <md-toolbar class="md-transparent" md-elevation="0">
        <img id="logo" src="./assets/app-logo.png" />
        <h3 class="md-title" style="flex: 1">DECKBOARD</h3>
      </md-toolbar>
      <md-content class="content content-1 md-layout md-gutter">
        <div class="md-layout-item highlight-text">
          <div class="highlight-inner">
            <h1>Custom shortcut for your PC on your phone.</h1>
            <div class="download-button-group">
              <a :href="release.download_url">
                <md-button class="button-download windows" v-show="os.includes('Win')">
                  <div class="button-content-inline">
                    <i class="fab fa-windows"></i> DOWNLOAD
                    <span class="label-version">Version {{release.version}} • Windows • {{release.size}}MB</span>
                  </div>
                </md-button>
              </a>
              <div v-show="os.includes('Android')">
                DOWNLOAD CLIENT<br>
                <img class="badge" src="./assets/google-play-badge.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="md-layout-item highlight-img">
          <img class="highlight-display" id="screenshot-1" src="./assets/00.png" />
        </div>
      </md-content>
      <md-content class="content content-2">
        <div class="feature-item">
          <div>
            <img src="./assets/03.png" />
          </div>
          <div>
            <h2>Easy macros!</h2>
            <p>Create infinite shortcuts for every needs, from opening website, folder, run program, and keyboard macros!</p>
          </div>
        </div>
        <div class="feature-item">
          <div>
            <img src="./assets/image4144.png" />
          </div>
          <div>
            <h2>Make 'em yours</h2>
            <p>Organize your shortcuts board and add your prefered images on each shortcuts to your liking.</p>
          </div>
        </div>
        <div class="feature-item">
          <div>
            <img src="./assets/05.png" />
          </div>
          <div>
            <h2>Simple and clean</h2>
            <p>Use your smartphone to access the shortcuts. Just connect your phone to your PC through the WiFi and tap which
              shortcut you want to run.</p>
          </div>
          <div>
          </div>
        </div>
      </md-content>
      <md-content class="content content-3 md-alignment-center">
        <h2>DOWNLOAD</h2>
        <div class="button-download-group">
          <div class="button-download-platform">
            <a :href="release.download_url">
              <md-button class="button-download general">
                <i class="fab fa-windows"></i> WINDOWS
              </md-button>
            </a>
            <div class="label-platform">Version {{release.version}} • EXE • {{release.size}}MB</div>
          </div>
          <div class="button-download-platform">
            <md-button class="button-download general">
              <i class="fab fa-linux"></i> LINUX
            </md-button>
            <div class="label-platform">COMING SOON!</div>
          </div>
        </div>
        <h2>MOBILE CLIENT</h2>
        <a href="https://play.google.com/store/apps/details?id=com.rivafarabi.deckboard">
          <img class="badge" src="./assets/google-play-badge.png" />
        </a>
        <div>Google Play and the Google Play logo are trademarks of Google LLC.</div>
      </md-content>
      <md-content class="content content-4 md-alignment-center">
        Copyright © 2018 Riva Farabi
      </md-content>
    </md-content>
  </div>
</template>
<script>
import GithubServices from './services/github-services'
const githubService = new GithubServices()

export default {
  name: 'App',
  data () {
    return {
      os: navigator.platform,
      release: null
    }
  },
  mounted () {
    githubService.fetchLatestRelease()
      .then(data => {
        this.release = data
      })
  }
}
</script>

<style lang="stylus">
@import './styles/home.styl'
</style>



// WEBPACK FOOTER //
// src/App.vue